const Gallery = {
  init () {

    /*
    * Gallery - lightgallery
    */

    if ( jQuery('.c-gallery').length ) {
      jQuery('.c-gallery').lightGallery({
				selector: '.c-gallery-item',
				thumbnail: true,
				showThumbByDefault: false,
				download: false
			});
    }

  }
};

export default Gallery;
